/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Calendar_PrevInputs */

const cs_calendar_prev = /** @type {(inputs: Calendar_PrevInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Předchozí období`)
};

const en_calendar_prev = /** @type {(inputs: Calendar_PrevInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Previous period`)
};

/**
* | output |
* | --- |
* | "Previous period" |
*
* @param {Calendar_PrevInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const calendar_prev = /** @type {((inputs?: Calendar_PrevInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Calendar_PrevInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_calendar_prev(inputs)
	return cs_calendar_prev(inputs)
});